import { render, staticRenderFns } from "./stockist-loan-trx-table.vue?vue&type=template&id=eae28fe8&"
import script from "./stockist-loan-trx-table.vue?vue&type=script&lang=js&"
export * from "./stockist-loan-trx-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports